import { render, staticRenderFns } from "./TabLaboratorio.vue?vue&type=template&id=665bf47e&scoped=true&"
import script from "./TabLaboratorio.vue?vue&type=script&lang=js&"
export * from "./TabLaboratorio.vue?vue&type=script&lang=js&"
import style0 from "./TabLaboratorio.vue?vue&type=style&index=0&id=665bf47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bf47e",
  null
  
)

export default component.exports